module.exports = __webpack_public_path__ + "img/buynow.9433f228.png";